import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

const NoDataPopup = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToUpload = () => {
    const modal = document.querySelector("#close-btn");
    modal.click();

    navigate(props.url, { replace: true });
  };

  return (
    <>
      {/* Delete Performance Indicator Modal */}
      <div
        className="modal custom-modal fade"
        id="NoDataPopup"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{t("noDataFound")}</h3>
                <p>{t("uploadData")}</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <button
                      onClick={handleGoToUpload}
                      className="btn btn-primary continue-btn"
                    >
                      {t("goToUploadPage")}
                    </button>
                  </div>
                  <div className="col-6">
                    <Link
                      to="#"
                      id="close-btn"
                      data-bs-dismiss="modal"
                      className="btn btn-primary cancel-btn"
                    >
                      {t("close")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default NoDataPopup;
